// extracted by mini-css-extract-plugin
export var grayCircle = "_dg-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_dg-1";
export var selectedCircle = "_dg-2";
export var shippingOptionImage = "_dg-3";
export var shippingOptionWidgetPreview = "_dg-4";